import routerOptions0 from "/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/app/router.options.ts";
const configRouterOptions = {
  linkActiveClass: "link-active",
  linkExactActiveClass: "link-exact-active text-primary",
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}